// Scales the numeric portion of a quantity string by `factor`.
// Handles: "200g", "2 tsp", "1.5 cups", "1/2 cup", "1 1/2 tbsp", "3 sprigs".
// Returns the original string if no leading number found.
export function scaleQuantity(qty, factor) {
  if (!qty || typeof qty !== "string") return qty;
  if (Math.abs(factor - 1) < 0.001) return qty;

  const trimmed = qty.trim();
  // Match leading: mixed fraction ("1 1/2"), fraction ("1/2"), decimal ("1.5"), or integer ("200")
  const match = trimmed.match(/^(\d+\s+\d+\/\d+|\d+\/\d+|\d+\.\d+|\d+)/);
  if (!match) return qty;

  const numStr = match[1];
  const rest = trimmed.slice(numStr.length);

  const parseNum = (s) => {
    if (s.includes(" ") && s.includes("/")) {
      const [whole, frac] = s.split(/\s+/);
      const [n, d] = frac.split("/").map(Number);
      return Number(whole) + n / d;
    }
    if (s.includes("/")) {
      const [n, d] = s.split("/").map(Number);
      return n / d;
    }
    return Number(s);
  };

  const value = parseNum(numStr);
  const scaled = value * factor;

  // Round nicely
  let rendered;
  if (scaled >= 100) {
    rendered = String(Math.round(scaled / 5) * 5); // nearest 5 for large amounts
  } else if (scaled >= 10) {
    rendered = String(Math.round(scaled));
  } else if (scaled >= 1) {
    rendered = String(Math.round(scaled * 4) / 4); // nearest 1/4
  } else {
    rendered = String(Math.round(scaled * 10) / 10);
  }

  return rendered + rest;
}
